export default function translate(propriete) {
  if (propriete === 'to') {
    return 'mail.error.to';
  }
  if (propriete === 'objet') {
    return 'mail.error.objet';
  }
  if (propriete === 'corps') {
    return 'mail.error.corps';
  }
  if (propriete === 'from') {
    return 'mail.error.from';
  }
  if (propriete.indexOf('personalizations') === 0) {
    return '';
  }
  return propriete;
}
